
//@flow
import React, {useEffect} from 'react';
import {Box, Button, Typography} from "@mui/material";
import {useHistory} from "react-router-dom";

type Props = {
    type: 'failure' | 'cancel',
    message: string,
    redirectTo: string,
    redirectDelay?: number,
};

const PaymentStatusPage = ({
    type,
    message,
    redirectTo,
    redirectDelay = 4000,
}: Props) => {

    const history = useHistory();

    // useEffect(() => {
    //
    //     const timeout = setTimeout(() => {
    //         history.push(redirectTo);
    //     }, redirectDelay);
    //
    //     return () => clearTimeout(timeout);
    //
    // }, [history, redirectDelay, redirectTo]);

    const isFailure = type === 'failure';

    return (
        <Box
            sx={{
                minHeight: '100vh',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 500,
                    borderRadius: '24px',
                    backgroundColor: '#fff',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                    p: {xs: 4, md: 5},
                    textAlign: 'center',
                    border: `2px solid ${isFailure ? '#D32F2F' : '#ED6C02'}`,
                }}
            >
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        mb: 2,
                        color: isFailure ? '#D32F2F' : '#ED6C02',
                    }}
                >
                    {isFailure
                        ? 'Payment Failed'
                        : 'Payment Cancelled'}
                </Typography>

                <Typography
                    sx={{
                        fontSize: '16px',
                        lineHeight: 1.7,
                        color: '#444',
                    }}
                >
                    {message}
                </Typography>

                <Typography
                    sx={{
                        mt: 3,
                        fontSize: '14px',
                        color: '#888',
                    }}
                >
                    Redirecting to cart...
                </Typography>
                <Button onClick={()=>history.push(redirectTo)}>
                    Redirect
                </Button>
            </Box>
        </Box>
    );
};

export default PaymentStatusPage;

